import {useSearchParams} from "react-router-dom";
import {useEffect} from "react";
import {APP_CONSTANTS} from "@/utilities/constants/AppConstants.ts";
import AppDownloadCTA from "@/components/public/AppDownloadCTA.tsx";

export const MarketingRedirect = () => {
  const [searchParams] = useSearchParams();
  useEffect(() => {
    const redirectUrlParam = searchParams.get('redirect');
    let redirectUrl = '';
    console.log("searc", searchParams.toString())
    switch (redirectUrlParam) {
      case 'android':
        redirectUrl = `${APP_CONSTANTS.APP_DOWNLOAD.ANDROID}`;
        break;
      case 'ios':
        redirectUrl = `${APP_CONSTANTS.APP_DOWNLOAD.IOS}`;
        break;
      // default:
        // redirectUrl = `https://saveforlater.pro`;
    }
    if (redirectUrl) {
      window.location.href = redirectUrl + (redirectUrl.includes('?') ? '&' : '?') + searchParams.toString();
    }
  }, [])
  return (
    <div className="min-h-screen flex gap-8 flex-col items-center justify-center bg-[var(--color-background)]">
      <AppDownloadCTA/>
      {searchParams.get('redirect') && <div className="text-[var(--color-text)]">
          Redirecting to download page...
      </div>}
    </div>
  );
}
